import { CircularProgress as MuiCircularProgress } from "@mui/material";

export const Loader = () => {
  return <MuiCircularProgress size={35} />;
};
